import React from "react"
import classes from "./OrderRecapItem.module.css"
import { SanityImg } from "../../../../../cms/components"
import ProductLabel from "../../../../../ui/molecules/Product/ProductLabel"
import QuantityPopup from "../../../../../ui/molecules/QuantityPopup"
import Square from "../../../../../ui/shapes/Square"
import { BasketItem } from "../../../state/checkoutTypes"
import classNames from "classnames"
import ProductPrice from "../../../../../ui/molecules/Product/ProductPrice"
import Typography from "../../../../../ui/atoms/Typography"
import { GiftIcon } from "../../../../../ui/icons/GiftIcon"
import { GIFTCARD_IMAGE_REF } from "../../../data"

interface Props {
  item: BasketItem
  className?: string
  priceOverride?: string
}

const getProductImage = (item: BasketItem) => {
  if (item.type === "giftcard") {
    return GIFTCARD_IMAGE_REF
  }

  return item.variant?.media.productImages[0]?.asset
}

const OrderRecapItem = ({ item, className, priceOverride }: Props) => {
  const price =
    item.order.total.discountedPrice ?? item.order.total.originalPrice
  const compareAtPrice =
    item.order.total.compareAtPrice ?? item.order.total.originalPrice
  return (
    <div className={classes.root}>
      <div className={classNames(classes.product, className)}>
        <div className={classes.img}>
          <QuantityPopup
            quantity={item.order.quantity}
            dotClassName={classes.dot}
          >
            <Square center>
              <SanityImg fluid asset={getProductImage(item)} />
            </Square>
          </QuantityPopup>
        </div>
        <div className={classes.label}>
          <ProductLabel
            title={item.product?.metadata.brand?.name}
            subtitle={item.variant?.contents?.name?.toLowerCase()}
            className={classes.productLabel}
          >
            {item.variant?.info.color?.name || item.variant?.info.quantity ? (
              <Typography variant="body2">
                {item.variant?.info.color?.name ?? item.variant?.info.quantity}
              </Typography>
            ) : undefined}
          </ProductLabel>

          <div className={classes.priceRow}>
            {item.order.gift && (
              <div className="flex justify-end mb-1">
                <GiftIcon
                  style={{
                    width: 30,
                  }}
                />
              </div>
            )}

            {priceOverride ? (
              <Typography weight="boldest">{priceOverride}</Typography>
            ) : (
              <ProductPrice
                price={price}
                compareAtPrice={compareAtPrice}
                currencyPosition="after"
                layout="vertical"
                className={classes.productPrice}
                classes={{
                  price: classes.price,
                  compareAtPrice: classes.compareAtPrice,
                }}
              />
            )}
          </div>
        </div>
      </div>
    </div>
  )
}

export default OrderRecapItem
